/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdParams,
  PostProjectsPrototypesPartialsBatchByProjectIdAndPrototypeIdParams,
  PostProjectsPrototypesPartialsBatchByProjectIdAndPrototypeIdQuery,
  PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody,
  PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdResponse,
  PostProjectsPrototypesPartialsBatchByProjectIdAndPrototypeIdResponse,
} from '../types';

export class Partials extends Controller {
  async postProjectsPrototypesPartialsByProjectIdAndPrototypeId<
    T extends PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdResponse,
    D,
    C extends PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/projects/${projectId}/prototypes/${prototypeId}/partials`,
      body,
      axiosConfig
    );
  }

  async postProjectsPrototypesPartialsBatchByProjectIdAndPrototypeId<
    T extends PostProjectsPrototypesPartialsBatchByProjectIdAndPrototypeIdResponse,
    D,
    C extends null
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PostProjectsPrototypesPartialsBatchByProjectIdAndPrototypeIdParams,
    query: PostProjectsPrototypesPartialsBatchByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/projects/${projectId}/prototypes/${prototypeId}/partials/batch`,
        query
      ),
      body,
      axiosConfig
    );
  }
}
